import { SensorPortCommunicationMode } from "../../../portConfigs.js";
import { SensorClusterConfig, SensorElementOutput } from "../types.js";

function makeZoneVirtualCluster(
    friendlyName: string,
    friendlyShortName: string,
    elements: SensorElementOutput<any>[],
): SensorClusterConfig<Record<string, never>> {
    return {
        communicationMode: SensorPortCommunicationMode.DIGITAL,
        requiredSubChannels: [],
        optionalSubChannels: [],
        isPermanentlyAttached: true,
        parameterConfigs: {},
        manufacturerName: "Verdi",
        modelName: friendlyName,
        friendlyName,
        friendlyShortName,
        // Return deeply-cloned descriptors each call to avoid cross-call mutation sharing.
        generateSensorElements: () => elements.map((element) => structuredClone(element)),
    };
}

export const zoneVirtualClusterConfigs: Record<string, SensorClusterConfig<Record<string, never>>> = {
    Zone_NDVI: makeZoneVirtualCluster("Zone NDVI", "NDVI", [
        {
            sensorElementConfigKey: "zoneNdvi",
            parameters: {},
            legalConvertedRange: [-1, 1],
            subChannel: 0,
        },
        {
            sensorElementConfigKey: "zoneNdviVariance",
            parameters: {},
            legalConvertedRange: [0, null],
            subChannel: 1,
        },
    ]),

    Zone_Precipitation: makeZoneVirtualCluster("Zone Precipitation", "Precipitation", [
        {
            sensorElementConfigKey: "digitalPrecipitation",
            parameters: {},
            legalConvertedRange: [0, null],
            subChannel: 0,
        },
    ]),

    Zone_ValveOpenPercent: makeZoneVirtualCluster("Zone Valve Open Percent", "Open %", [
        {
            sensorElementConfigKey: "digitalPercentage",
            parameters: {},
            legalConvertedRange: [0, 1],
            subChannel: 0,
        },
    ]),

    Zone_ValveOnlinePercent: makeZoneVirtualCluster("Zone Valve Online Percent", "Online %", [
        {
            sensorElementConfigKey: "digitalPercentage",
            parameters: {},
            legalConvertedRange: [0, 1],
            subChannel: 0,
        },
    ]),

    Zone_ZoneIrrigationScheduled: makeZoneVirtualCluster("Zone Irrigation Scheduled", "Scheduled", [
        {
            sensorElementConfigKey: "zoneIrrigationScheduled",
            parameters: {},
            legalConvertedRange: [null, null],
            subChannel: 0,
        },
    ]),
};
